import {FC, useCallback, useEffect, useState} from 'react'
import {Modal, Spinner} from 'react-bootstrap'
import {KTSVG} from '../../../../../../_metronic/helpers'
import Select from 'react-select'
import {
  useAttachTagToSegmentMutation,
  useLazyGetAllTagsQuery,
} from '../../../../../../services/cellcast'
import {toast} from 'react-toastify'

type AddTagModalProps = {
  show: boolean
  segmentId: string
  handleClose: () => void
}

const AddTagModal: FC<AddTagModalProps> = (props) => {
  const {show, segmentId, handleClose} = props

  const [fetchTags, {data: tagsResponse, isLoading: tagsLoading, isFetching: tagsFetching}] =
    useLazyGetAllTagsQuery()
  const [attachTags, {isLoading: attachLoading}] = useAttachTagToSegmentMutation()

  const [tagOptions, setTagOptions] = useState<any[]>([])
  const [selectedIds, setSelectedIds] = useState<string[]>([])

  useEffect(() => {
    if (show === true) {
      fetchTags(null)
    }
  }, [show])

  useEffect(() => {
    if (tagsResponse && tagsResponse.data && Array.isArray(tagsResponse.data)) {
      const filterTags = tagsResponse.data.filter((el) => el.type && el.type !== 'list')
      const tagOptions = filterTags.map((el) => ({
        label: el.name,
        value: el._id,
      }))

      setTagOptions(tagOptions)
    }
  }, [tagsResponse])

  const handleChange = (selectedData: {label: string; value: string}[]) => {
    const ids = selectedData.map((el) => el.value)
    const uniqueIds = Array.from(new Set(ids))
    setSelectedIds(uniqueIds)
  }
  const handleSubmit = useCallback(() => {
    attachTags({segmentId: segmentId, tagIds: selectedIds})
      .then((res) => {
        if ('data' in res) {
          toast.success(res.data?.message)

          if (handleClose) {
            handleClose()
          }
        } else if ('error' in res) {
          const errObj = res.error as any
          if (errObj.data.message) {
            toast.error(errObj.data.message)
          } else {
            toast.error(res.error)
          }
        }
      })
      .catch((err) => {
        toast.error(err.error)
      })
  }, [attachTags, handleClose, segmentId, selectedIds])

  return (
    <Modal show={show} onHide={handleClose} dialogClassName='modal-dialog-centered mw-450px'>
      <div className='modal-header'>
        <h2>Add Tags</h2>
        <div className='btn btn-icon btn-sm' onClick={handleClose}>
          <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2' />
        </div>
      </div>
      <div className='modal-body'>
        <label className='col-form-label fw-bold fs-6'>Tag name</label>
        <Select
          value={tagOptions.filter((el) => selectedIds.includes(el.value))}
          isMulti
          className='react-tags-selectbox'
          options={tagOptions}
          onChange={handleChange as any}
          isDisabled={tagsFetching || tagsLoading || attachLoading}
        />
      </div>
      <div className='modal-footer d-flex justify-content-end m-0'>
        <button
          onClick={() => {
            handleClose()
            setSelectedIds([])
          }}
          type='button'
          className='btn btn-light-primary'
        >
          Cancel
        </button>
        <button onClick={handleSubmit} id='submit' type='button' className='btn btn-primary'>
          {attachLoading ? <Spinner size='sm' animation='grow' /> : 'Submit'}
        </button>
      </div>
    </Modal>
  )
}

export default AddTagModal
